import Text from 'components/Text/Text';

const NotFound = () => {
  return (
    <div className="h-80 w-full d-flex content-center items-center">
      <Text variant="p" size="md" align="center">
        404 | Page not found
      </Text>
    </div>
  );
};

export default NotFound;
